import React from 'react'

class RatingDiscretion extends React.Component {
  componentDidMount() {
    setTimeout( this.props.hide, 4000)
  }

  render() {
    return (
      <div className="rating-discretion">
        <div className="content">
          <div
            onClick={ () => { window.history.go(-1) } }
            className="back site-border-color">
            Back
          </div>
          <div className="warning site-color">WARNING</div>
          <div className="rating-container site-border-color">
            <div className="label">The following content is rated:</div>
            <div className="rating">{ this.props.rating }</div>
          </div>
          <div className="discretion">Viewer Discretion Is Advised</div>
        </div>
      </div>
    )
  }
}

export default RatingDiscretion
